var CheckoutConsentsManager = {
    cookieChecked: true,
    cookiesStatus : {
        userHasSetCookies: true,
        functionalityCookies: true,
        marketingCookies: true,
        statisticCookies: true
    }
};

try {
    if (Cookies.get('ConsentChecked'))
        CheckoutConsentsManager.cookiesStatus = $.extend({}, CheckoutConsentsManager.cookiesStatus, JSON.parse(Cookies.get('ConsentChecked')));

    CheckoutConsentsManager.userHasSetCookies = true;
}
catch (e) {        
    console.log(e);
}

function InitCheckoutFunctions() {

    $('html,body').on('dragstart', function (event) {
        event.preventDefault();
        return false;
    });

    $('html,body').on('drop', function (event) {
        event.preventDefault();
        return false;
    });

    $('.prevstep').click(function () {
        ShowLoading();
    });

    if ($('.checkoutstep2.pay').length > 0) {
        $('.checkoutstep2.pay').click(function () {
            var chkSameAsShipping = $('.chkSameAsShipping>input');
            var chkInvoice = $('.chkInvoice>input');
            if (Page_ClientValidate('checkoutShippingVld')) {
                if (chkSameAsShipping.is(':checked')) {
                    if (chkInvoice.is(':checked')) {
                        var isValid = Page_ClientValidate('checkoutInvoiceVld');
                        if (isValid)
                            ShowLoading();
                        else
                            goToInstantly('invoicetype');
                    }
                    else {
                        ShowLoading();
                        return true;
                    }
                }
                else {
                    var isValid = Page_ClientValidate('checkoutBillingVld');

                    if (isValid) {
                        if (chkInvoice.is(':checked')) {
                            var isValid = Page_ClientValidate('checkoutInvoiceVld');
                            if (isValid)
                                ShowLoading();
                            else
                                goToInstantly('invoicetype');
                        }
                        else {
                            ShowLoading();
                        }
                    }
                    else
                        goToInstantly('billing');

                    return isValid;
                }
            }
            else
                goToInstantly('shipping');
        });


        $('.chkSameAsShipping>input').click(function () {
            if ($(this).is(':checked')) {
                $('.billing .forms').slideUp('slow');
                $('.billing').addClass('hidden');
                $('.billing .TopError.Summary').hide();
            }
            else {
                $('.billing .forms').slideDown('slow');
                $('.billing').removeClass('hidden');
            }
        });

        $('.NumbersOnlyField').keydown(numbersOnly);
        $('.PhoneField').each(function(){
            $(this).keydown(phoneGROnly)
        });

        if (($('.checkoutstep2').length > 0) && (getQueryStringParameter('addbilling') != '')) {
            goToByScroll('billing');
        }

        var vldInvoiceCompanyName = $('.vldInvoiceCompanyName').get(0);
        var vldInvoiceOccupation = $('.vldInvoiceOccupation').get(0);
        var vldInvoiceTaxAgency = $('.vldInvoiceTaxAgency').get(0);
        var vldInvoiceTaxIdentifier = $('.vldInvoiceTaxIdentifier').get(0);
        setupInvoice(vldInvoiceCompanyName, vldInvoiceOccupation, vldInvoiceTaxAgency, vldInvoiceTaxIdentifier);

        $('.chkInvoice>input').click(function () {
            if ($(this).is(':checked')) {
                $('.invoicetype .forms').slideDown('slow');
                $('.invoicetype').removeClass('hidden');
                $('.chkNotInvoice>input').removeAttr('checked');
                setupInvoice(vldInvoiceCompanyName, vldInvoiceOccupation, vldInvoiceTaxAgency, vldInvoiceTaxIdentifier);
            }
            else {
                $(this).attr('checked', 'checked');
            }
        });

        $('.chkNotInvoice>input').click(function () {
            if ($(this).is(':checked')) {
                $('.invoicetype .forms').slideUp('slow');
                $('.invoicetype').addClass('hidden');
                $('.chkInvoice>input').removeAttr('checked');
                setupInvoice(vldInvoiceCompanyName, vldInvoiceOccupation, vldInvoiceTaxAgency, vldInvoiceTaxIdentifier);
            }
            else {
                $(this).attr('checked', 'checked');
            }
        });
    }

    if ($('.checkoutstep3.pay').length > 0) {
        var txtSmallFormPassword = $('.txtSmallFormPassword');
        var txtSmallFormPasswordConfirm = $('.txtSmallFormPasswordConfirm');
        $('.checkoutstep3.pay').click(function () {
            if (((txtSmallFormPassword.val() != '') && (txtSmallFormPassword.length > 0)) || ((txtSmallFormPasswordConfirm.val() != '') && (txtSmallFormPasswordConfirm.length > 0))) {
                var isValid = Page_ClientValidate('checkoutVld');
                if (!isValid)
                    goToInstantly('termsFancyLink');
                else {
                    isValid = TermsOfUseCheckBoxRequired_ClientValidate();
                    if (isValid)
                        ShowLoading();
                    else
                        goToByScroll('chkAcceptTerms');
                }

                return isValid;
            }
            else {
                var isValid = TermsOfUseCheckBoxRequired_ClientValidate();
                if (isValid)
                    ShowLoading();
                else
                    goToByScroll('chkAcceptTerms');
                return isValid;
            }
        });

        $('.txtSmallFormPassword').blur(function () {
            if (((txtSmallFormPassword.val() != '') && (txtSmallFormPassword.length > 0)) || ((txtSmallFormPasswordConfirm.val() != '') && (txtSmallFormPasswordConfirm.length > 0))) {
                ValidatorEnable($('.vldName').get()[0], true);
                ValidatorEnable($('.vldSurname').get()[0], true);
                ValidatorEnable($('.vldEmail').get()[0], true);
                ValidatorEnable($('.vldEmailRight').get()[0], true);
                ValidatorEnable($('.vldPassReg').get()[0], true);
                ValidatorEnable($('.vldPassCompare').get()[0], true);
                ValidatorEnable($('.vldPassRegConfirm').get()[0], true);

                $('.bottom .input').each(function () {
                    $(this).addClass('error');
                    $(this).children('label, div').addClass('error');
                });
            }
            else {
                ValidatorEnable($('.vldName').get()[0], false);
                ValidatorEnable($('.vldSurname').get()[0], false);
                ValidatorEnable($('.vldEmail').get()[0], false);
                ValidatorEnable($('.vldEmailRight').get()[0], false);
                ValidatorEnable($('.vldPassReg').get()[0], false);
                ValidatorEnable($('.vldPassCompare').get()[0], false);
                ValidatorEnable($('.vldPassRegConfirm').get()[0], false);

                $('.bottom .input').each(function () {
                    $(this).removeClass('error');
                    $(this).children('label, div').removeClass('error');
                });

            }
        });
    }

    $('.InvokeOnSelectChangePagePreloader').change(function () {
        ShowLoading();
    });
    
    window.ScriptsActivator.loadAllScripts(
        CheckoutConsentsManager.cookiesStatus.functionalityCookies,
        CheckoutConsentsManager.cookiesStatus.marketingCookies,
        CheckoutConsentsManager.cookiesStatus.statisticCookies
    );        

    initTooltips();

    if (checkoutConfig.convertToGreek)
        convertToGreek();

    if (checkoutConfig.convertToUppercase)
        convertToUppercase();
}

function setupInvoice(val1, val2, val3, val4) {

    if (val1 === undefined || val2 === undefined || val3 === undefined || val4 === undefined)
        return;

    if (!$(".chkInvoice>input").is(":checked")) {
        $('.companyname').val('');
        $('.occupation').val('');
        $('.taxagency').val('');
        $('.taxidentifier').val('');
    }

    var check = $(".chkInvoice>input").is(":checked");
    val1.initialvalue = '';
    val2.initialvalue = '';
    val3.initialvalue = '';
    val4.initialvalue = '';

    var companyname = $('.companyname').val();
    var occupation = $('.occupation').val();
    var taxagency = $('.taxagency').val();
    var taxidentifier = $('.taxidentifier').val();
    $('.companyname').val('.');
    $('.occupation').val('.');
    $('.taxagency').val('.');
    $('.taxidentifier').val('.');

    ValidatorEnable(val1, check);
    ValidatorEnable(val2, check);
    ValidatorEnable(val3, check);
    ValidatorEnable(val4, check);

    $('.companyname').val(companyname);
    $('.occupation').val(occupation);
    $('.taxagency').val(taxagency);
    $('.taxidentifier').val(taxidentifier);
}
function TermsOfUseCheckBoxRequired_ClientValidate() {
    var isValid = $('.chkAcceptTerms>input').is(':checked');
    if (isValid) {
        $('.checkout-next-prev .input').removeClass('termsError');
        $('.checkout-next-prev .input .error').removeClass('termsError');
        $('.checkout-next-prev .input .error .message').hide();
    }
    else {
        $('.checkout-next-prev .input').addClass('termsError');
        $('.checkout-next-prev .input .error').addClass('termsError');
        $('.checkout-next-prev .input .error .message').show();
    }
    return isValid;
}
if ($('.termsFancyLink').length > 0) {
    $('.termsFancyLink').fancybox({
        type: 'iframe'
    });
}
function ShowLoading() {
    $('#SiteLoading').show();
}
function HideLoading() {
    $('#SiteLoading').hide();
}
function getQueryStringParameter(param) {
    var url = window.location.toString();
    url.match(/\?(.+)$/);
    var params = RegExp.$1;
    var params = params.split("&");
    var queryStringList = {};

    for (var i = 0; i < params.length; i++) {
        var tmp = params[i].split("=");
        queryStringList[tmp[0]] = unescape(tmp[1]);
    }
    var result = '';
    for (var i in queryStringList) {
        if (i == param) {
            result = queryStringList[i];
            return result;
        }
    }
    return result;
}
function CheckEmail(email) {
    var filter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+[.])+([a-zA-Z0-9]{2,20})+$/;
    if (!filter.test(email)) {
        return false;
    }
    else
        return true;
}
function checkMobileGR(phone) {
    var filter = /\b69\d{8}\b/;
    if (!filter.test(phone)) {
        return false;
    }
    else
        return true;
}
function checkPhoneGR(phone) {
    var filter = /\b2\d{9}\b/;
    if (!filter.test(phone)) {
        return false;
    }
    else
        return true;
}
function goToByScroll(id) {
    if ($("#" + id).length != 0)
        $('html,body').animate({ scrollTop: $("#" + id).offset().top }, 1000);
    else if ($("." + id).length != 0)
        $('html,body').animate({ scrollTop: $("." + id).offset().top }, 1000);
    else
        $('html,body').animate({ scrollTop: $(id).offset().top }, 1000);
}
function goToInstantly(id) {
    if ($("#" + id).length != 0)
        $('html,body').animate({ scrollTop: $("#" + id).offset().top }, 0);
    else if ($("." + id).length != 0)
        $('html,body').animate({ scrollTop: $("." + id).offset().top }, 0);
    else
        $('html,body').animate({ scrollTop: $(id).offset().top }, 0);
}

function initTooltips() {
    var $wrapper = $('.tooltip-info-wrapper');

    if ($wrapper.length < 1)
        return;

    $('.info-btn', $wrapper).click(function () {
        var tooltipBox = $(this).siblings('.info-tooltip');
        $('.info-tooltip', $wrapper).not(tooltipBox).hide();
        tooltipBox.toggle();
    });

    $(document).on('click', function (e) {
        if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
            $('.info-tooltip', $wrapper).hide();
        }
    });
}